import { useCachedContentQuery } from 'PublicWebApi'
import { type PropsWithChildren, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

const scrollToTop = () => window.scrollTo(0, 0)

const scrollToHash = (hash: string) => {
  const targetElement = document.getElementById(decodeURI(hash.slice(1)))
  setTimeout(() => {
    targetElement?.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }, 50)
}

const ScrollWrapper = ({ children }: PropsWithChildren<unknown>) => {
  const {
    location: { state },
    action,
  } = useHistory<{ preventScroll?: boolean }>()
  const { hash } = useLocation()
  const { data: contentData } = useCachedContentQuery()
  const contentUrl = contentData?.properties.url

  useEffect(() => {
    // if prevented, do nothing
    if (state?.preventScroll) return
    // if navigation via forward/back and no hash is present, do nothing
    if (action === 'POP' && !hash) {
      return
    }
    // on link click with a has in the URL, scroll to hash
    if (hash && contentUrl) {
      scrollToHash(hash)
      return
    }
    // on every click navigation for links that dont go to a hash, scroll to top
    scrollToTop()
  }, [action, contentUrl, hash, state?.preventScroll])

  return <>{children}</>
}

export default ScrollWrapper
